import React from "react";
import { string } from "prop-types";
import PageTitle from "../../atoms/PageTitle";

import "./local-navigation-bar.m.css";

const LocalNavigationBar = ({ title = "Events", ...props }) => {
  return (
    <nav styleName="local-navigation-bar" {...props}>
      <div styleName="title-container">
        <PageTitle>{title}</PageTitle>
      </div>
    </nav>
  );
};

LocalNavigationBar.propTypes = {
  title: string
};

export default LocalNavigationBar;